import { getSessionStorageItemJson } from '@vfde-sails/storage';
import { SAILS_BNT_STORAGE } from '@vfde-sails/constants';
import { APP } from 'Constant';
import { SailsConnectMoreStorage } from '../interfaces/storage';
import { AbstractedUpsellItem } from '@vfde-sails/glados-v2';

/**
 * Get selected products from storage
 */
export const getAccessoriesFromStorage = (): AbstractedUpsellItem[] => {
    const storage = getSessionStorageItemJson<SailsConnectMoreStorage>(SAILS_BNT_STORAGE);

    return storage?.[APP]?.selectedAccessories.map((id: string) => ({
        id,
    } as AbstractedUpsellItem)) || [];
};
